import BaseModel from '../base/BaseModel.model';
import { PermissionValue } from '@/enums/PermissionValue';
import { PermissionAccessLevel } from '@/enums/PermissionAccessLevel';

export default class RolePermission extends BaseModel {

    public permissionId?: number ;
    public roleId?: number;
    public permissionAccessLevel: PermissionAccessLevel = 0;
    
    //This property is inherit from Permission.PermissionValue. It is only a DTO property.
    public permissionValue:PermissionValue = 0;
    
    constructor(){
        super();
        this.init();
    }

    init(){
        this.id = 0;
        this.permissionId = 0;
        this.permissionAccessLevel = 0;
        this.roleId = 0;
        this.permissionValue = 0;
    }
}